import './ColorPicker.css';

import React, { useState } from 'react';
import reactCSS from 'reactcss'
import { CompactPicker } from 'react-color';

const ColorPicker = ({ initColor, label, name, onChangeColor }) => {

    const [color, setColor] = useState(initColor);
    const [displayColorPicker, setdisplayColorPicker] = useState(false);

    const styles = reactCSS({
        'default': {
            color: {
                width: '36px',
                height: '14px',
                borderRadius: '2px',
                background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
            },
            swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    });

    if (initColor !== color) {
        // we need to update the color if we change it from parent (by using the restore defaults button)
        setColor(initColor);
    }

    const handleColorChange = (color) => {
        setColor(color.rgb);
        onChangeColor(color, name);
    }

    return (
        <div>
            <div style={styles.swatch} onClick={() => setdisplayColorPicker(true)}>
                <div style={{backgroundColor: `rgba(${color.r}, ${color.g}, ${color.b}, 1)`, borderRadius: '2px', width: '36px', height: '14px' }} />
            </div>
            {displayColorPicker ? <div style={styles.popover}>
                <div style={styles.cover} onClick={() => setdisplayColorPicker(false)} />
                <CompactPicker color={color} onChangeComplete={handleColorChange} />
            </div> : null}
            <label>{ label }</label>
        </div>
    )

}

export default ColorPicker;